import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-6560">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-6561">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-6562">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-6563">
            <ArrowLeft className="w-4 h-4" data-id="element-6564" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-6565">NOIZA</div>
          <div className="w-20" data-id="element-6566" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-6567">
        <div className="mb-12" data-id="element-6568">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-6569">
            <FileText className="w-6 h-6 text-white/80" data-id="element-6570" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-6571">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-6572">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-6573">
          <section data-id="element-6574">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6575">
              <span className="text-[#006847]" data-id="element-6576">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6577">
              <p data-id="element-6578">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-6579">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6580">
                <li data-id="element-6581">Haber leído íntegramente este documento</li>
                <li data-id="element-6582">Comprender su contenido en su totalidad</li>
                <li data-id="element-6583">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-6584">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-6585">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6586">
              <span className="text-[#006847]" data-id="element-6587">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6588">
              <p data-id="element-6589">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6590">
                <li data-id="element-6591">Software como servicio (SaaS)</li>
                <li data-id="element-6592">Marketplace digital gastronómico</li>
                <li data-id="element-6593">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-6594">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6595">
                <li data-id="element-6596">Mostrar su menú digital</li>
                <li data-id="element-6597">Recibir pedidos de clientes</li>
                <li data-id="element-6598">Gestionar su operación interna</li>
                <li data-id="element-6599">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-6600">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-6601">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6602">
              <span className="text-[#006847]" data-id="element-6603">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6604">
              <p data-id="element-6605">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6606">
                <li data-id="element-6607">No es proveedor de alimentos</li>
                <li data-id="element-6608">No participa en la preparación de productos</li>
                <li data-id="element-6609">No manipula alimentos en ningún momento</li>
                <li data-id="element-6610">No realiza entregas ni logística</li>
                <li data-id="element-6611">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-6612">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-6613">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-6614">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6615">
              <span className="text-[#006847]" data-id="element-6616">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-6617">
              <p data-id="element-6618">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-6619">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6620">
                <li data-id="element-6621">El restaurante es el único responsable de su operación</li>
                <li data-id="element-6622">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-6623">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-6624">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6625">
                <li data-id="element-6626">Precios</li>
                <li data-id="element-6627">Menú</li>
                <li data-id="element-6628">Horarios</li>
                <li data-id="element-6629">Métodos de pago</li>
                <li data-id="element-6630">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6631">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6632">
              <span className="text-[#006847]" data-id="element-6633">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-6634">
              <div data-id="element-6635">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6636">
                  5.1. Alcance general
                </h3>
                <p data-id="element-6637">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-6638">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6639">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-6640">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6641">
                  <li data-id="element-6642">Calidad de los alimentos</li>
                  <li data-id="element-6643">Estado, frescura o preparación</li>
                  <li data-id="element-6644">Ingredientes utilizados</li>
                  <li data-id="element-6645">Contaminación cruzada</li>
                  <li data-id="element-6646">Problemas de higiene o salubridad</li>
                  <li data-id="element-6647">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6648">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-6649">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6650">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-6651">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6652">
                  <li data-id="element-6653">Retrasos en la entrega</li>
                  <li data-id="element-6654">Pérdida de pedidos</li>
                  <li data-id="element-6655">Entregas incompletas</li>
                  <li data-id="element-6656">Errores en dirección</li>
                  <li data-id="element-6657">Conducta de repartidores</li>
                  <li data-id="element-6658">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-6659">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6660">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-6661">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-6662">
                  <li data-id="element-6663">Recepción de pagos</li>
                  <li data-id="element-6664">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-6665">Manejo de efectivo</li>
                  <li data-id="element-6666">Confirmación de pagos</li>
                  <li data-id="element-6667">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-6668">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6669">
                  <li data-id="element-6670">Pagos no recibidos</li>
                  <li data-id="element-6671">Comprobantes falsos</li>
                  <li data-id="element-6672">Errores en montos</li>
                  <li data-id="element-6673">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-6674">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6675">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-6676">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6677">
                  <li data-id="element-6678">Reclamos de clientes</li>
                  <li data-id="element-6679">Reembolsos</li>
                  <li data-id="element-6680">Cancelaciones</li>
                  <li data-id="element-6681">Disputas</li>
                  <li data-id="element-6682">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6683">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-6684">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6685">
              <span className="text-[#006847]" data-id="element-6686">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-6687">
              <p data-id="element-6688">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6689">
                <li data-id="element-6690">Responsable</li>
                <li data-id="element-6691">Legal</li>
                <li data-id="element-6692">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-6693">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6694">
                <li data-id="element-6695">Publicar información falsa</li>
                <li data-id="element-6696">Manipular precios de forma engañosa</li>
                <li data-id="element-6697">Simular disponibilidad inexistente</li>
                <li data-id="element-6698">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6699">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6700">
              <span className="text-[#006847]" data-id="element-6701">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-6702">
              <p data-id="element-6703">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6704">
                <li data-id="element-6705">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-6706">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-6707">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6708">
                <li data-id="element-6709">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-6710">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-6711">
                    <li data-id="element-6712">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-6713">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-6714">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6715">
              <span className="text-[#006847]" data-id="element-6716">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-6717">
              <p data-id="element-6718">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6719">
                <li data-id="element-6720">Menú digital</li>
                <li data-id="element-6721">Gestión de pedidos</li>
                <li data-id="element-6722">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-6723">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6724">
                  <p className="font-medium text-white mb-2" data-id="element-6725">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6726">
                    <li data-id="element-6727">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6728">
                  <p className="font-medium text-white mb-2" data-id="element-6729">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6730">
                    <li data-id="element-6731">Propiedad del software</li>
                    <li data-id="element-6732">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-6733">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-6734">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6735">
              <span className="text-[#006847]" data-id="element-6736">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6737">
              <p data-id="element-6738">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6739">
                <li data-id="element-6740">Disponibilidad continua</li>
                <li data-id="element-6741">Funcionamiento sin interrupciones</li>
                <li data-id="element-6742">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-6743">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6744">
                <li data-id="element-6745">Fallas técnicas</li>
                <li data-id="element-6746">Actualizaciones</li>
                <li data-id="element-6747">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-6748">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-6749">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6750">
              <span className="text-[#006847]" data-id="element-6751">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-6752">
              <p data-id="element-6753">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6754">
                <li data-id="element-6755">No está garantizada permanentemente</li>
                <li data-id="element-6756">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-6757">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6758">
                <li data-id="element-6759">Destacar o no restaurantes</li>
                <li data-id="element-6760">Modificar posiciones</li>
                <li data-id="element-6761">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6762">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6763">
              <span className="text-[#006847]" data-id="element-6764">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-6765">
              <p data-id="element-6766">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6767">
                <li data-id="element-6768">Cumplir con los pagos acordados</li>
                <li data-id="element-6769">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-6770">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6771">
                <li data-id="element-6772">Suspender el servicio</li>
                <li data-id="element-6773">Limitar funcionalidades</li>
                <li data-id="element-6774">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6775">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6776">
              <span className="text-[#006847]" data-id="element-6777">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6778">
              <p data-id="element-6779">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6780">
                <li data-id="element-6781">Incumplimiento de términos</li>
                <li data-id="element-6782">Uso indebido</li>
                <li data-id="element-6783">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-6784">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-6785">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6786">
              <span className="text-[#006847]" data-id="element-6787">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-6788">
              <p data-id="element-6789">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-6790">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-6791">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6792">
              <span className="text-[#006847]" data-id="element-6793">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-6794">
              <p data-id="element-6795">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6796">
                <li data-id="element-6797">Pérdidas económicas</li>
                <li data-id="element-6798">Daños indirectos</li>
                <li data-id="element-6799">Lucro cesante</li>
                <li data-id="element-6800">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6801">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6802">
              <span className="text-[#006847]" data-id="element-6803">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-6804">
              <p data-id="element-6805">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-6806">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6807">
              <span className="text-[#006847]" data-id="element-6808">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-6809">
              <p className="font-medium" data-id="element-6810">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-6811">
                <li data-id="element-6812">Ha leído este documento completo</li>
                <li data-id="element-6813">Comprende su alcance</li>
                <li data-id="element-6814">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}